<template>
    <Component
        :is="instance"
        v-bind="optionalProps"
        v-on="optionalListeners"
    />
</template>

<script>
export default {
    name: 'GlobalPopups',
    data() {
        return {
            instance: undefined,
            optionalProps: undefined,
            optionalListeners: undefined,
        };
    },
    beforeDestroy() {
        this.$popup.unsubscribe();
    },
    created() {
        if (process.browser) {
            this.$popup.subscribe(({ instance, optionalProps, optionalListeners }) => {
                this.instance = instance;
                this.optionalProps = optionalProps;
                this.optionalListeners = optionalListeners;
            });
        }
    },
};
</script>
